import React from 'react';
import PropTypes from 'prop-types'
const uuid = require('uuid');

const SiteConfigStore = require('../../stores/SiteConfigStore');
const SiteConfigActions = require('../../actions/SiteConfigActions');
import MessageBar from '../common/MessageBar';

const propTypes = {};

const defaultProps = {};

class SiteMessageBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            siteMessage: SiteConfigStore.getState().siteMessage
        };

        this.unsubscribes = [SiteConfigStore.listen(this.onSiteConfigStoreStateChange.bind(this))];
    }

    UNSAFE_componentWillMount() {
        SiteConfigActions.getSiteMessage(uuid.v4());
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onSiteConfigStoreStateChange(state) {
        this.setState({ siteMessage: state.siteMessage });
    }

    render() {
        return (
            <MessageBar className="mzl-cs-announce">
                <span dangerouslySetInnerHTML={{__html: this.state.siteMessage}} />
            </MessageBar>
        );
    }
}

SiteMessageBar.propTypes = propTypes;
SiteMessageBar.defaultProps = defaultProps;

export default SiteMessageBar;